module.exports = {"330185002":"玲珑街道","330185005":"锦南街道","330185006":"锦城街道","330185007":"锦北街道","330185008":"青山湖街道","330185102":"高虹镇","330185103":"太湖源镇","330185104":"於潜镇","330185106":"太阳镇","330185107":"潜川镇","330185108":"昌化镇","330185109":"河桥镇","330185111":"湍口镇","330185112":"清凉峰镇","330185113":"岛石镇","330185115":"板桥镇","330185116":"天目山镇","330185117":"龙岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330185.json
// module id = 954
// module chunks = 0